// let timeBack = 10;
// const handleF = () => {
//   const target = $(".productitem--action-trigger");
//   if (target.length > 0) {
//     $(target).on("click", () => {
//       setTimeout(() => {
//         BSS_B2B.cp.changeProductPrice(
//           JSON.parse($("#bss-b2b-store-data").html()),
//           "[bss-b2b-variant-id]",
//           false,
//           false
//         );
//         timeBack = 10;
//         setTimeout(handleF, 300);
//       }, 1000);
//     });
//   } else if (timeBack-- > 0) {
//     setTimeout(handleF, 300);
//   }
// };
// handleF();

// BSS_B2B.customErrorElementFieldRF = (key, form, parentElement) => {
//   if (key === "RegisterForm-email") {
//     return $("#register_email");
//   }

//   return parentElement;
// };

$(document).on("click", ".productitem--action-trigger", function () {
  setTimeout(() => {
    BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
  }, 1000);
});


